import PromoBg from "assets/png/promo_man_alt_1.png";
import styled from "styled-components";

import { Container as BaseContainer, HeaderContainerColumn } from "../styles";

const containerHeight = 560;
const promoBgImageHeight = 459;
const containerInnerWidth = 400;

export const Container = styled(BaseContainer)`
  height: ${containerHeight}px;
  background-image: url("${PromoBg}");
  background-size: auto ${promoBgImageHeight}px;
`;

export const LockedMessageContainer = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.colors.colorsNew.gray[300]};
  border-radius: 8px;
  padding: ${({ theme }) => theme.padding.p8};
  gap: 12px;
  margin-bottom: ${({ theme }) => theme.margin.m16};
`;

export const LockIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.colorsNew.gray[200]};

  border-radius: 4px;
  padding: 5px;

  svg {
    height: 20px;
    width: 20px;
  }
`;

export const HeaderContainer = styled(HeaderContainerColumn)``;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: ${containerInnerWidth}px;
`;
